/**
 * @generated SignedSource<<c4c4127d880ed202bbdb396c7657b996>>
 * @relayHash cefbf5713efcd88acc5ca16bb98e75f5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/CheckoutEmailOnlyShippingFormRegisterMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type UserRegisterEmailOnlyErrorCode = "EMAIL_ONLY_ACCOUNT_EXISTS" | "FULL_ACCOUNT_EXISTS" | "%future added value";
export type UserRegisterEmailOnlyInput = {
  authHash: string;
  captchaKey?: string | null;
  captchaToken?: string | null;
  clientMutationId?: string | null;
  cookieDomain?: string | null;
  currency?: Currency | null;
  email: string;
  isGdprApplicable?: boolean | null;
  registrationTrigger?: string | null;
};
export type CheckoutEmailOnlyShippingFormRegisterMutation$variables = {
  input: UserRegisterEmailOnlyInput;
};
export type CheckoutEmailOnlyShippingFormRegisterMutation$data = {
  readonly userRegisterEmailOnly: {
    readonly email: string | null;
    readonly errorCode: UserRegisterEmailOnlyErrorCode | null;
    readonly userExistsMetadata: {
      readonly " $fragmentSpreads": FragmentRefs<"checkoutAuthActions_userExistsMetadata">;
    } | null;
    readonly userId: string | null;
  } | null;
};
export type CheckoutEmailOnlyShippingFormRegisterMutation = {
  response: CheckoutEmailOnlyShippingFormRegisterMutation$data;
  variables: CheckoutEmailOnlyShippingFormRegisterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorCode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPassword",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasFacebook",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasGoogle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasApple",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailOnly",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckoutEmailOnlyShippingFormRegisterMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserRegisterEmailOnlyPayload",
        "kind": "LinkedField",
        "name": "userRegisterEmailOnly",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserExistsMetadataType",
            "kind": "LinkedField",
            "name": "userExistsMetadata",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "checkoutAuthActions_userExistsMetadata",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckoutEmailOnlyShippingFormRegisterMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserRegisterEmailOnlyPayload",
        "kind": "LinkedField",
        "name": "userRegisterEmailOnly",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserExistsMetadataType",
            "kind": "LinkedField",
            "name": "userExistsMetadata",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/CheckoutEmailOnlyShippingFormRegisterMutation",
    "metadata": {},
    "name": "CheckoutEmailOnlyShippingFormRegisterMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ba5dff9aa3377b55fa5fc541b6a0d0ab";

export default node;
